import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class ReasonCodeDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      applied_to,
      preload = true,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='reason_code'
          type='reason_code'
          valueField='id'
          preload={preload}
          searchParams={{
            applied_to
          }}
          component={multiple ? renderSearchMultipleDropdown : renderSearchDropDown}
          onPostChange={onPostChange}
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ReasonCodeDropdown);
